export default __webpack_public_path__ + "static/media/OpenxSVGLogo.c08e0e71.svg";